import { Injectable, EventEmitter } from '@angular/core'
import PouchDB from 'pouchdb';
import 'rxjs/add/operator/map';
import { fakeAsync } from '@angular/core/testing';


@Injectable({
    providedIn: 'root'
})
export class ServiceOffLine {
    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();


    constructor() {
        if (!this.isInstantiated) {
            var katios = this.GetIdKatiosLVL1FromSession();
            this.database = new PouchDB("Offline" + katios, { auto_compaction: true });
            this.isInstantiated = true;
        }
    }


    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    public get(id: string) {
        return this.database.get(id);
    }

    //Adicionar en BD pouch.
    public AddDocument(id: string, document: any) {
        document._id = id;

        console.log("AddDocument");
        return this.get(id).then(result => {
            console.log("AddDocument enconrtro document");
            document._rev = result._rev;
            return this.database.put(document);
        }, error => {
            console.log(error.status);
            if (error.status == "404") {
                delete document["_rev"];
                return this.database.put(document);
            } else {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
        });
    }

    // public Destroy() {
    //     this.database.destroy().then(function (response) {
    //         setTimeout(() => {
    //             this.database = new PouchDB("Offline");
    //         }, 2000);
    //     }).catch(function (err) {
    //         console.log(err);
    //     });
    // }

    public DestroyTotal(){
        this.database.destroy();
    }

    public GetAllDocsDeleted() {
        return this.database.allDocs({ include_docs: true, deleted: true });
    }

    public GetAllDocs() {
        return this.database.allDocs({ include_docs: true });
    }

    public GetAllDocsOffLineSinDocs() {
        return this.database.allDocs({ include_docs: false });
    }

    public Destroy(funcionRep:Function) {
        this.database.destroy().then(response => {
            setTimeout(() => {
                var katios = this.GetIdKatiosLVL1FromSession();
                this.database = new PouchDB("OfflineLog" + katios, { auto_compaction: true });
                funcionRep({"Resp":"OK"});
            }, 2000);
        }).catch(function (err) {
            funcionRep({"Resp":"Error", "Desc":err});
            console.log(err);
        });
    }
    public DeleteAllDocs() {
        this.database.allDocs({ include_docs: true }).then(allDocs => {
            return allDocs.rows.filter(row => !row.id.startsWith("CTIVOS")).map(function (row) {
                return { _id: row.id, _rev: row.doc._rev, _deleted: true };
            });
        }).then(deleteDocs => {
            return this.database.bulkDocs(deleteDocs);
        });
    }

    public Delete(isKey: string) {
        this.database.get(isKey).then(result => {
            return this.database.remove(result);
        });
    }
}